import { render, staticRenderFns } from "./SBPAdvanceDialog.vue?vue&type=template&id=2f27085e&"
import script from "./SBPAdvanceDialog.vue?vue&type=script&lang=js&"
export * from "./SBPAdvanceDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports